/**
 * App-weite UI-Präferenzen (nicht Business-Payload).
 */

import { kvGet, kvSet } from '../infrastructure/storage/kvAccess';
import { PRINT_ROLE, setPrinterRoleAssignment } from '../domain/print';
import { normalizePrinterForSave } from '../utils/printerIdentity';

export function getAppCurrency() {
  try {
    return kvGet('appCurrency') || null;
  } catch {
    return null;
  }
}

export function setAppCurrency(currency) {
  if (currency == null || currency === '') return;
  kvSet('appCurrency', currency);
}

export function setSavedPrinter(printer) {
  const normalized = normalizePrinterForSave(printer);
  if (!normalized?.deviceName) return;
  // Receipt role is the legacy single-printer preference (POS bon).
  setPrinterRoleAssignment(PRINT_ROLE.RECEIPT, normalized);
}
